/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ unit: NonNullable<unknown> }} Exercise_Sheet_How_Per_HandInputs */

const en_us2_exercise_sheet_how_per_hand = /** @type {(inputs: Exercise_Sheet_How_Per_HandInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Log the weight of ONE dumbbell, in the “${i?.unit}” field; the volume counts both.`)
};

const pt_br2_exercise_sheet_how_per_hand = /** @type {(inputs: Exercise_Sheet_How_Per_HandInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Registre o peso de UM halter, no campo “${i?.unit}”; o volume conta os dois.`)
};

const es_419_exercise_sheet_how_per_hand = /** @type {(inputs: Exercise_Sheet_How_Per_HandInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Registra el peso de UNA mancuerna, en el campo “${i?.unit}”; el volumen cuenta las dos.`)
};

const pt_pt2_exercise_sheet_how_per_hand = /** @type {(inputs: Exercise_Sheet_How_Per_HandInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Regista o peso de UM haltere, no campo “${i?.unit}”; o volume conta os dois.`)
};

const fr_fr2_exercise_sheet_how_per_hand = /** @type {(inputs: Exercise_Sheet_How_Per_HandInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Note le poids d'UN haltère, dans le champ « ${i?.unit} » ; le volume compte les deux.`)
};

const de_de2_exercise_sheet_how_per_hand = /** @type {(inputs: Exercise_Sheet_How_Per_HandInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trag das Gewicht EINER Kurzhantel im Feld „${i?.unit}“ ein; das Volumen zählt beide.`)
};

const it_it2_exercise_sheet_how_per_hand = /** @type {(inputs: Exercise_Sheet_How_Per_HandInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Registra il peso di UN manubrio, nel campo “${i?.unit}”; il volume conta entrambi.`)
};

/**
* | output |
* | --- |
* | "Log the weight of ONE dumbbell, in the “{unit}” field; the volume counts both." |
*
* @param {Exercise_Sheet_How_Per_HandInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_how_per_hand = /** @type {((inputs: Exercise_Sheet_How_Per_HandInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_How_Per_HandInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_how_per_hand(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_how_per_hand(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_how_per_hand(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_how_per_hand(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_how_per_hand(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_how_per_hand(inputs)
	return en_us2_exercise_sheet_how_per_hand(inputs)
});
export { exercise_sheet_how_per_hand as "exercise-sheet.how_per_hand" }